export default {"src":"/_next/static/media/submit-green.e1db0a8f.svg","height":46,"width":37};